<template>
    <div class="bto-sb-widget bto-sb-widget-collapsed
      bto-sb-widget-sportlist-menu bto-sb-widget-livesportlist-menu bto-sb-widget-liveupcoming-menu"
      :class="{'bto-sb-widget-collapsed-active' : expanded}">
        <div class="bto-sb-widget-title bto-sb-widget-title-icon" @click="toggleWidgetExpand()">
            <span class="bto-sb-widget-title-icon"></span>
            <h3>{{t('Mobile.Upcoming')}}</h3>
            <span class="bto-sb-widget-title-arrow"></span>
        </div>
        <div ref="ufmenu">
            <div>
                <div class="bto-sb-widget-content" v-show="expanded">
                    <ul>
                        <li
                                v-for="([sportId, matchesNo], idx) in Object.entries(sports)"
                                :key="idx"
                        >
          <span class="bto-sb-sportlist-menu-item" @click="toggleActive(idx, sportId)">
            <span class="bto-sb-sports-icon" :class="getSportClass(sportId)"></span>
            <span class="bto-sb-sportlist-menu-sport-name">{{getSportName(sportId)}}</span>
            <span class="bto-sb-sportlist-menu-sport-events">{{matchesNo}}</span>
          </span>
                            <ul class="bto-sb-sportlist-menu-level-3" v-show="activeTabs[idx]">
                                <li
                                        v-for="(sportMatch, idx) in matches[sportId]"
                                        :key="idx"
                                        :class="{'bto-sb-sportlist-menu-item-active' : activeMatchId == sportMatch.matchId}"
                                >
              <span class="bto-sb-sportlist-menu-item">
                <a href="javascript:void(0);" @click="upcomingMatchClick(sportMatch)">
                  <span class="bto-sb-sportlist-menu-tournament-name">{{sportMatch.homeTeam}} {{t('Mobile.VS')}} {{sportMatch.guestTeam}}</span>
                  <span class="bto-sb-sportlist-menu-tournament-match-live">{{sportMatch.date}} {{sportMatch.time}}</span>
                </a>
              </span>
                                    <favorite-component :match="sportMatch" :isFixture="true"/>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import Vue from 'vue';
  import store from '../../../store/index';
  import FavoriteComponent from '../../shared/favorite-component';
  import { EventBus } from '../../../services/event-bus-service';
  import UpcomingFixtureService from './service-upcoming-fixture';
  import UpcomingService from '../upcoming/service-upcoming';
  import MatchDetailsModel from '../match-details/prematch/model-match-details-prematch';

  export default {
    name: 'UpcomingFixtureMenuWidget',
    components: {
      FavoriteComponent,
    },
    data() {
      return {
        upcomingRequest: new UpcomingService(),
        expanded: true,
        activeTabs: {},
        sports: {},
        matches: {},
        activeMatchId: this.$router.currentRoute.params.matchId || 0,
      };
    },
    props: {
      endRecord: {
        type: String,
        default: '50',
        label: 'number of matches',
      },
      numberOfMarkets: {
        type: String,
        default: '3',
        label: 'number of markets',
      },
    },
    created() {
      let upcomingFixtureRequest = new UpcomingFixtureService();
      upcomingFixtureRequest.execute((response) => {
        this.sports = response.data;
      }).catch((error) => {
        console.error(error); // eslint-disable-line
      });
    },
    mounted() {
      EventBus.$on('leftColToggle', (expanded) => {
        if (expanded) {
          if (typeof this.$refs.ufmenu !== 'undefined') {
            Vue.prototype.$vuebar.destroyScrollbar(this.$refs.ufmenu, { clearStyles: true });
            this.$refs.ufmenu.firstElementChild.removeAttribute("style");
          }
        } else {
          this.$nextTick(() => {
            setTimeout(() => {
              if (typeof this.$refs.ufmenu !== 'undefined') {
                this.$refs.ufmenu.style.height = `${400}px`;
                Vue.prototype.$vuebar.initScrollbar(this.$refs.ufmenu, {});
              }
            }, 0);
          });
        }
      });
    },
    methods: {
      getSportMatches(sportId = null) {
        this.upcomingRequest.getParams.SportID = sportId;
        this.upcomingRequest.getParams.StartRecord = 0;
        this.upcomingRequest.getParams.EndRecord = parseFloat(this.endRecord);
        this.upcomingRequest.getParams.NumberOfOddTypes = parseFloat(this.numberOfMarkets);
        this.upcomingRequest.getParams.Minutes = 1440; // 1 day
        this.upcomingRequest.execute().then((response) => {
          this.matches[sportId || response.data.s[0]] = response.data.m.map(m => new MatchDetailsModel(m));
          this.matches = Object.assign({}, this.matches);
        }).catch((error) => {
          console.error(error); // eslint-disable-line
        });
      },
      toggleActive(idx, sportId) {
        if (this.activeTabs[idx]) {
          delete this.activeTabs[idx];
        } else {
          this.activeTabs[idx] = true;
          this.getSportMatches(sportId);
        }
        this.activeTabs = Object.assign({}, this.activeTabs);
      },
      getSportName(sportId) {
        return store.getters.getSportName(sportId);
      },
      getSportClass(sportId) {
        return store.getters.getSportClass(sportId);
      },
      upcomingMatchClick(match) {
        EventBus.$emit('upcomingFixtureMatchClicked', match);
      },
      toggleWidgetExpand() {
        this.expanded = !this.expanded;
      },
    },
    watch: {
      '$route': function (to) {
        if (to.params.matchType === 'prematch') {
          this.activeMatchId = to.params.matchId;
        } else {
          this.activeMatchId = null;
        }
      }
    },
  };
</script>
